import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { Form } from 'react-final-form'
import PageTitle from '../../components/page-title'
import AgreementPreviewModal from '../../components/agreement-preview-modal'
import { INITIAL_VALUES } from './constants'
import { validate, hasRequiredDraftValues, hasRequiredSelectValues } from './utils'
import AgreementFormFields from './AgreementFormFields'
import useAllClients from './useAllClients'
import styles from './index.module.scss'

function FormHeader ({ values, invalid, isBusy, onSaveDraft, onPublish }) {
  return (
    <div className={styles.pageHeader}>
      <PageTitle className={styles.pageTitle}>Create T&C Template</PageTitle>
      <div className={styles.actions}>
        <button
          type='button'
          className='dis-btn dis-btn-lg dis-btn-blank'
          disabled={!hasRequiredDraftValues(values) || isBusy}
          onClick={onSaveDraft}>
          SAVE AS DRAFT
        </button>
        <button
          type='button'
          className='dis-btn dis-btn-lg dis-btn-primary'
          disabled={invalid || !hasRequiredSelectValues(values) || isBusy}
          onClick={onPublish}>
          Save Changes & Enable
          <i className='material-icons dis-btn-icon'>check</i>
        </button>
      </div>
    </div>
  )
}

export default function CreateTermsAndConditionAgreementForm ({ onSubmit, isSaving }) {
  const submitStatusRef = useRef('published')
  const [showPreview, setShowPreview] = useState(false)
  const [previewContent, setPreviewContent] = useState('')
  const { clients, isClientsFetching } = useAllClients()

  function openPreview (content) {
    setPreviewContent(content || '')
    setShowPreview(true)
  }

  return (
    <Form
      initialValues={INITIAL_VALUES}
      validate={validate}
      onSubmit={(values) => onSubmit(values, submitStatusRef.current === 'published')}>
      {({ handleSubmit, form, values, invalid, submitting }) => {
        const isBusy = isSaving || submitting

        function submitAs (publish) {
          submitStatusRef.current = publish ? 'published' : 'draft'
          handleSubmit()
        }

        return (
          <form
            autoComplete='off'
            onSubmit={(event) => {
              event.preventDefault()
            }}>
            <FormHeader
              values={values}
              invalid={invalid}
              isBusy={isBusy}
              onSaveDraft={() => submitAs(false)}
              onPublish={() => submitAs(true)}
            />
            <AgreementFormFields
              form={form}
              values={values}
              isDisabled={isBusy}
              editorId='agreement-content'
              onPreview={openPreview}
            />
            <AgreementPreviewModal
              show={showPreview}
              onHide={() => setShowPreview(false)}
              content={previewContent}
              clients={clients}
              isClientsFetching={isClientsFetching}
            />
          </form>
        )
      }}
    </Form>
  )
}

FormHeader.propTypes = {
  values: PropTypes.object.isRequired,
  invalid: PropTypes.bool,
  isBusy: PropTypes.bool,
  onSaveDraft: PropTypes.func.isRequired,
  onPublish: PropTypes.func.isRequired
}

CreateTermsAndConditionAgreementForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  isSaving: PropTypes.bool
}
